import { render, staticRenderFns } from "./CookieConsentModal.vue?vue&type=template&id=055ea6a7&scoped=true&"
import script from "./CookieConsentModal.vue?vue&type=script&lang=js&"
export * from "./CookieConsentModal.vue?vue&type=script&lang=js&"
import style0 from "./CookieConsentModal.vue?vue&type=style&index=0&id=055ea6a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055ea6a7",
  null
  
)

export default component.exports